import { render } from "./k-confirm-close.vue?vue&type=template&id=24a85ae8"
import script from "./k-confirm-close.vue?vue&type=script&lang=js"
export * from "./k-confirm-close.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../../Users/martijn/Documents/GitHub/dfm/DFM-admin-Frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__